export const oneOf =
  <T>(values: T[]) =>
  (value: T) =>
    values.indexOf(value) !== -1;
